import { washArabic } from '@/utils/wash.js'
const washData = (node) => {
  try {
    washArabic(node)
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
